module.exports = __webpack_public_path__ + "media/images/sk5-a60a7911def6cd175e595a37b5341c98.svg";